import AudienceInsightsReducer from './AudienceInsightsReducer';

export default from './AudienceInsightsContainer';

export const AudienceInsightsReducers = {
  AudienceInsightsReducer,
};
